export default __webpack_public_path__ + "static/media/classic.3409a15c.png";